const apiRequestTypesMap = {
  get: 'get',
  delete: 'delete',
  post: 'post',
  put: 'put',
}

export default apiRequestTypesMap
